import { z } from "zod";
import { PaginationResponseSchema } from "./pagination";

export const CreateTournamentStatusRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  slug: z.string().min(1, "El slug es requerido"),
  description: z.string().optional(),
  color: z.string().optional(),
  isActive: z.boolean().optional().default(true),
  sortOrder: z.number().optional().default(0),
  isSystem: z.boolean().optional().default(false),
  canDelete: z.boolean().optional().default(true),
  canEdit: z.boolean().optional().default(true),
});

export const UpdateTournamentStatusRequestSchema =
  CreateTournamentStatusRequestSchema.partial();

export type CreateTournamentStatusRequestDTO = z.infer<
  typeof CreateTournamentStatusRequestSchema
>;
export type UpdateTournamentStatusRequestDTO = z.infer<
  typeof UpdateTournamentStatusRequestSchema
>;

export const TournamentStatusResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable(),
  color: z.string().nullable(),
  isActive: z.boolean(),
  sortOrder: z.number(),
  isSystem: z.boolean(),
  canDelete: z.boolean(),
  canEdit: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TournamentStatusResponseDTO = z.infer<
  typeof TournamentStatusResponseSchema
>;

export const TournamentStatusesPaginatedResponseSchema =
  PaginationResponseSchema(TournamentStatusResponseSchema);
export type TournamentStatusesPaginatedResponseDTO = z.infer<
  typeof TournamentStatusesPaginatedResponseSchema
>;
